import Cookies from "js-cookie";
import { fixVoicePingDomain } from "../constant";

const SERVER_API_URL = fixVoicePingDomain(process.env.VITE_BACKEND_BASE_URL) || "/api/v1";
const ETHERPAD_COOKIE_DOMAINS = process.env.VITE_ETHERPAD_COOKIE_DOMAIN?.split(",").map(domain => domain.trim());

const defaultHeader = {
  "Content-Type": "application/json",
};

export async function deleteEtherpadSession(etherpadSessionId: string, workspaceId: number) {
  try {
    const response = await fetch(`${SERVER_API_URL}/etherpad/delete-session`, {
      method: "POST",
      headers: defaultHeader,
      body: JSON.stringify({
        sessionID: etherpadSessionId,
        workspaceId,
      }),
      credentials: "include",
    });

    if (response.status === 200) {
      const result = await response.json();

      if (result.success) {
        Cookies.remove("currentEtherpadSessionID");
        Cookies.remove("sessionID");
        ETHERPAD_COOKIE_DOMAINS?.map(domain => Cookies.remove("sessionID", { domain: domain }));

        return true;
      } else {
        return false;
      }
    }
    return false;
  } catch (err) {
    console.error(err);
    return false;
  }
}

export async function createEtherpadSession(workspaceId: number) {
  try {
    const response = await fetch(`${SERVER_API_URL}/etherpad/create-session`, {
      method: "POST",
      headers: defaultHeader,
      body: JSON.stringify({
        workspaceId,
      }),
      credentials: "include",
    });

    if (response.status === 200) {
      const result = await response.json();

      if (result.success) {
        const oldSessionId = Cookies.get("currentEtherpadSessionID");

        if (oldSessionId) {
          await deleteEtherpadSession(oldSessionId, workspaceId);
        }

        Cookies.set("currentEtherpadSessionID", result.data.sessionID, { expires: 365 * 100 });
        ETHERPAD_COOKIE_DOMAINS?.map(domain =>
          Cookies.set("sessionID", result.data.sessionID, { expires: 365 * 100, domain: domain }),
        );

        return result.data.sessionID;
      } else {
        return false;
      }
    } else {
      throw new Error(`Can't create Etherpad SESSION with "workspaceId: ${workspaceId}". Error: ${response.status}`);
    }
  } catch (err) {
    console.error(err);
    return false;
  }
}

export async function getRevisionCount(padID: string, workspaceId: number) {
  try {
    const response = await fetch(
      `${SERVER_API_URL}/etherpad/revisions-count?workspaceId=${workspaceId}&padID=${encodeURIComponent(padID)}`,
      {
        method: "GET",
        headers: defaultHeader,
        credentials: "include",
      },
    );

    if (response.status === 200) {
      const result = await response.json();

      if (result.success) {
        return result.data.revisions;
      } else {
        return -1;
      }
    } else {
      throw new Error(`Can't get revision count for "PadID: ${padID}". Error: ${response.status}`);
    }
  } catch (err) {
    console.error(err);
    return -1;
  }
}
